import UIUtils from 'js/lib/UIUtils';
import { has } from 'lodash';
import classes from 'new/components/flows/configure/ELT/ELTSourceSetup/SourceSetupPage.module.scss';
import TypographySupport from 'new/elements/TypographySupport/TypographySupport';
import { FieldBuilderRedesigned } from 'new/elements/FieldBuilderRedesigned/FieldBuilder';
import React from 'react';
import Tooltip from 'js/components/elements/mui/Tooltip';
import { ReactComponent as InfoIcon } from 'new/elements/flows/assets/info.svg';
import { MarkdownContent } from 'new/elements/MarkdownContent';

export const ResourceParamField = ({ field, onFieldUpdated, sourceConfig }) => {
  // const { sourceConfig } = useELT();
  const data = sourceConfig;

  if (UIUtils.shouldHideField(field, data) === true || !UIUtils.shouldRenderField(field, data)) {
    return null;
  }

  const defaultFieldValue = field?.default ?? '';
  const currentFieldValue =
    has(data, field.name) || has(data, field.fieldName)
      ? data[field.name || field.fieldName]
      : defaultFieldValue;
  const key = 'grp-' + field.name;
  const id = field.id || 'form-text' + field.name;

  const isCronField = field?.name === 'start.cron';

  const modifiedField = isCronField
    ? {
        ...field,
        display_name: '',
      }
    : field;

  let labelItem = null;

  if (field?.description && field?.description !== '' && !isCronField) {
    labelItem = (
      <label className={classes.inputLabelWithTooltip}>
        <TypographySupport variant="body2">{field.display_name}</TypographySupport>
        <div className={classes.infoIconContainer}>
          <Tooltip
            placement="right"
            tooltipTheme="fieldInfo"
            title={<MarkdownContent>{field.description}</MarkdownContent>}
            children={
              <div>
                <InfoIcon />
              </div>
            }
          />
        </div>
      </label>
    );
  } else if (isCronField) {
    labelItem = (
      <label className={classes.inputLabel}>
        <TypographySupport variant="body2">Fetch Data</TypographySupport>
      </label>
    );
  } else {
    labelItem = (
      <label className={classes.inputLabel}>
        <TypographySupport variant="body2">{field.display_name}</TypographySupport>
      </label>
    );
  }

  return (
    <div className={classes.inputRow} key={key}>
      {labelItem}
      <div className={classes.inputControl}>
        <FieldBuilderRedesigned
          field={modifiedField}
          id={id}
          currentFieldValue={currentFieldValue}
          labeled={false}
          showRequiredIndicator={false}
          skinnyFrequencyField={false}
          fieldLabelClassName={isCronField ? '' : classes.fieldBuilderLabel}
          onChange={onFieldUpdated}
        />
      </div>
    </div>
  );
};
